import styled from "styled-components";

export const Paragraph = styled.p`
  max-width: 550px;
  width: 100%;
  margin-bottom: 16px;
  text-align: ${({ textAlign }) => textAlign};
`;
